import React from 'react';
import styled from 'styled-components';
import {GetCardTypeForBody} from '../../../../../util/utils';

export default function Spacer(props) {
	const {options} = props;

	options?.bodyRelatedObjects && options?.bodyRelatedObjects !== null
		? options?.bodyRelatedObjects[0]?.priorYearAmount
		: null;

	const formBodyBorder = GetCardTypeForBody(options);

	return (
		<Wrapper className={`SpacerBody ${formBodyBorder}`}>
			<section className="SpacerBodySection" />
		</Wrapper>
	);
}

const Wrapper = styled.section`
	display: flex;
	.SpacerBodySection {
		height: var(--px-30);
	}
`;
